// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"d0e2911e","372":"20aee3fd","443":"96a1f62e","738":"e7130690","856":"b0702800"}[chunkId] + ".chunk.js";
};